import Crud from '../views/Local/Crud'
import Entity from '../views/Local/Add'

let routes = {
    path: '/locais',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/locais/add',
            name: 'NewSector',
            component: Entity,
            meta: {
                pageTitle: 'Local',
                access_nivel: ['6', '2'],
                breadcrumb: [
                    {
                        text: 'Adicionar Local',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/locais/edit/:id?',
            name: 'EditSector',
            component: Entity,
            meta: {
                pageTitle: 'Local',
                access_nivel: ['6', '2'],
                breadcrumb: [
                    {
                        text: 'Editar Local',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/locais',
            name: 'list-locais',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Locais',
                access_nivel: ['6', '2'],
                breadcrumb: [
                    {
                        text: 'Locais',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
